export default {
  props: {
    name: {
      type: String,
      default: 'Призыв к действию 1'
    },
    type: {
      type: String,
      default: 'message'
    },
    redirect: {
      type: String,
      default: 'whatsapp-and-telegram'
    },
    avatarEnabled: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    },
    isDark: {
      type: Boolean,
      default: false
    },
    branding: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    backgroundPosition: {
      type: String,
      default: 'left'
    },
    backgroundImage: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    },
    logoFile: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    },
    extraTextEnabled: {
      type: Boolean,
      default: false
    },
    whatsappButtonText: {
      type: String,
      default: ''
    },
    whatsappQrcodeText: {
      type: String,
      default: ''
    },
    telegramButtonText: {
      type: String,
      default: ''
    },
    telegramQrcodeText: {
      type: String,
      default: ''
    },
    operatorName: {
      type: String,
      default: ''
    },
    messageNumber1: {
      type: String,
      default: ''
    },
    messageNumber2: {
      type: String,
      default: ''
    },
    quickAnswerEnabled: {
      type: Boolean,
      default: false
    },
    quickAnswerValue: {
      type: Array,
      default: () => ([])
    },

    // QUERY
    queryMode: {
      type: String,
      default: 'any'
    },
    afterPageLoadEnabled: {
      type: Boolean,
      default: false
    },
    afterPageLoadSeconds: {
      type: Number,
      default: 30
    },
    pageScrollBelowEnabled: {
      type: Boolean,
      default: false
    },
    pageScrollBelowAmount: {
      type: Number,
      default: 30
    },
    deviceEnabled: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: String,
      default: 'desktop'
    },
    locationEnabled: {
      type: Boolean,
      default: false
    },
    locationMatcher: {
      type: String,
      default: 'includes'
    },
    locationValues: {
      type: Array,
      default: () => ([])
    }
  }
}
